import React from "react";
import { useAuth } from "@/lib/providers";
import Logo from "@/components/Logo";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div
      className="v-container"
      style={{ paddingTop: 64, paddingBottom: 120 }}
      data-testid="pending-approval-screen"
    >
      {/* Branded header */}
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 48 }}>
        <Logo size="md" />
        <span className="overline" style={{ color: "var(--v-text-3)" }}>
          Therefore Design · Packaging Audit
        </span>
      </div>

      <div className="overline" style={{ color: "var(--v-accent)" }}>Verdict · Request received</div>
      <h1
        className="display"
        style={{ fontSize: "clamp(40px,5vw,64px)", lineHeight: 1.05, marginTop: 12 }}
      >
        You're on the list.<br />Just waiting on the studio.
      </h1>
      <p
        style={{
          maxWidth: 680, marginTop: 20, fontSize: 16,
          color: "var(--v-text-2)", lineHeight: 1.6,
        }}
      >
        Hi {user?.name?.split(" ")[0] || "there"} — Verdict is by-invite outside the
        <span className="mono"> @thereforedesign.co.in </span>
        domain. We've notified the studio lead about your request and emailed you a
        confirmation. You'll receive a follow-up from us the moment access is granted, and
        you can come back to this URL to sign in again.
      </p>

      <div className="v-surface" style={{ padding: 24, marginTop: 32, maxWidth: 680 }}>
        <div className="overline">Request details</div>
        <div
          style={{
            marginTop: 12,
            display: "grid",
            gridTemplateColumns: "120px 1fr",
            rowGap: 10,
            fontSize: 14,
          }}
        >
          <div className="mono" style={{ color: "var(--v-text-2)" }}>Email</div>
          <div className="mono" data-testid="pending-email">{user?.email}</div>
          <div className="mono" style={{ color: "var(--v-text-2)" }}>Name</div>
          <div>{user?.name}</div>
          <div className="mono" style={{ color: "var(--v-text-2)" }}>Status</div>
          <div>
            <span
              style={{
                background: "var(--v-accent)", color: "#000",
                padding: "3px 12px", borderRadius: 999,
                fontSize: 11, fontWeight: 600, letterSpacing: ".06em",
              }}
            >
              Pending approval
            </span>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 32, display: "flex", gap: 12, flexWrap: "wrap" }}>
        <button
          className="v-btn v-btn-outline"
          onClick={logout}
          data-testid="pending-signout-btn"
        >
          Sign out
        </button>
        <a
          className="v-btn v-btn-outline"
          href="mailto:vrishali@thereforedesign.co.in?subject=Verdict%20access%20request"
          data-testid="pending-contact-link"
        >
          Email the studio lead
        </a>
      </div>
    </div>
  );
}
